import { HttpRequest, HttpResponse } from '@/data/protocols/http'
import { HttpStatusCode } from 'axios'
import { AxiosHttpClient } from '.'

export class AxiosHttpAuthClient extends AxiosHttpClient {
  private removeAuthorization: () => void

  constructor(removeAuthorization: () => void) {
    super()
    this.removeAuthorization = removeAuthorization
  }

  async request(data: HttpRequest): Promise<HttpResponse> {
    data.withCredentials = true
    const response = await super.request(data)
    if (this.unauthorizedError(response)) {
      this.removeAuthorization()
    }
    return response
  }

  private unauthorizedError(response: HttpResponse): boolean {
    return (
      response.statusCode === HttpStatusCode.Unauthorized ||
      (response.statusCode === HttpStatusCode.Ok &&
        (response.headers?.['content-type'] as string)?.startsWith('text/html'))
    )
  }
}
